'use client';

import { styled } from '@linaria/react';
import { NewsCategory } from '@fe-news/constants/categories';
import MemberSubHeader from '@fe-news/components/molecules/MemberHeader/MemberSubHeader';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

const CompileContainer = styled.div`
  display: flex;
  column-gap: 16px;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    margin-left: auto;
  }
`;

const MyTagHeaderSkeleton = () => {
  return (
    <HeaderContainer>
      <MemberSubHeader category={NewsCategory.MY_TAG} />
      <CompileContainer>
        <RectangleSkeleton width={78} height={35} />
        <RectangleSkeleton width={78} height={35} />
      </CompileContainer>
    </HeaderContainer>
  );
};

export default MyTagHeaderSkeleton;
